import { mergeClasses, __styles } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const menuGroupHeaderClassNames = {
  root: 'fui-MenuGroupHeader'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    Be2twd7: "fy9rknc",
    sj55zd: "f11d4kpn",
    uwmqm3: ["fjlbh76", "f11qrl6u"],
    z189sj: ["f11qrl6u", "fjlbh76"],
    Bhrd7zp: "fl43uef",
    Bqenvij: "f1d2rq10",
    mc9l5x: "f22iagw",
    Bt984gj: "f122n59"
  }
}, {
  d: [".fy9rknc{font-size:var(--fontSizeBase200);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".fjlbh76{padding-left:12px;}", ".f11qrl6u{padding-right:12px;}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1d2rq10{height:32px;}", ".f22iagw{display:flex;}", ".f122n59{align-items:center;}"]
});
export const useMenuGroupHeaderStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(menuGroupHeaderClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useMenuGroupHeaderStyles.styles.js.map